/** Привязки одной компании (вкладка «Сотрудники», UC1115): `v_corp_links` + `corp_link_*`. */
export const createCompanyLinksApi = (service, companyId) => ({
    scope: "company",
    list: (state) => service.getCompanyLinks(companyId, state),
    add: (input) => service.addLink(companyId, input),
    update: (linkId, patch) => service.updateLink(linkId, patch),
    setBlocked: (linkId, blocked, reason) => service.setBlocked(linkId, blocked, reason),
});
/** Привязки одного клиента ко всем компаниям («Компании клиента», UC1117): `v_corp_client_links`. */
export const createClientLinksApi = (service, clientId) => ({
    scope: "client",
    list: (state) => service.getClientLinks(clientId, state),
    add: async (input) => {
        if (!input.companyId)
            throw new Error("Компания не выбрана");
        return service.addLink(input.companyId, input);
    },
    update: (linkId, patch) => service.updateLink(linkId, patch),
    setBlocked: (linkId, blocked, reason) => service.setBlocked(linkId, blocked, reason),
});
